<template>
    <div class="row">
        <div class="col-xs-12">
            <h3>Bewerbung als</h3>
            <div class="header">{{ job ? job : $store.state.job }}</div>
            <div class="line"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['job'],
}
</script>
